<template>
  <div class="version-badge">v{{ version }}</div>
</template>

<script>
export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
    };
  },
};
</script>

<style scoped>
.version-badge {
  position: fixed;
  bottom: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.4);
  color: white;
  padding: 2px 6px;
  font-size: 12px;
  z-index: 9999;
  font-family: monospace;
}
</style>
